<template>
  <div class="new-layout-con new-layout-con-company">
    <div class="new-page-con">
      <Home></Home>
    </div>
  </div>
</template>

<script>
import Home from "@/views/home/home.vue";
export default {
  components: {
    Home,
  },
  data() {
    return {};
  },
};
</script>
